import "./App.css";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";
import Landing from "./components/landing/landing.component";
import Services from "./components/services/services.component";
import Story from "./components/story/story.component";
import Contact from "./components/contact/contact.component";
import Book from "./components/book/book.component";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/story" element={<Story />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<Book />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
